import { PermissionsScope } from '../../policies'

export const PACKING_LIST_SCOPE: PermissionsScope = 'packingLists'
export const PACKING_LIST_FRAGMENT = 'packing-lists'
export const NEW_PACKING_LIST_FRAGMENT = 'new-packing'
